import { render, staticRenderFns } from "./roles-filters.vue?vue&type=template&id=55a4ec8b&scoped=true&"
import script from "./roles-filters.vue?vue&type=script&lang=js&"
export * from "./roles-filters.vue?vue&type=script&lang=js&"
import style0 from "./roles-filters.vue?vue&type=style&index=0&id=55a4ec8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4ec8b",
  null
  
)

export default component.exports